import { SVGFC } from '@repo/toolkit/types'

const BoxIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6489 11.2821C10.8698 11.375 11.099 11.4468 11.3333 11.4965V20C11.1896 19.9628 11.0497 19.9119 10.9156 19.8482L5.58222 17.4632C5.11131 17.2526 4.71125 16.9093 4.43044 16.475C4.14964 16.0406 4.00013 15.5338 4 15.0158V9.06687C4.00071 8.82829 4.0336 8.59092 4.09778 8.36122L10.6489 11.2821ZM14.5067 9.29018L7.26222 5.86911L5.58222 6.61942C5.27924 6.75325 5.00464 6.94429 4.77333 7.18216L11.1822 10.0494C11.4397 10.1643 11.7183 10.2236 12 10.2236C12.2817 10.2236 12.5603 10.1643 12.8178 10.0494L14.5067 9.29018ZM19.2267 7.18216C18.9954 6.94429 18.7208 6.75325 18.4178 6.61942L13.0844 4.2345C12.7436 4.07994 12.3739 4 12 4C11.6261 4 11.2564 4.07994 10.9156 4.2345L8.88 5.14559L16.1244 8.56666L19.2267 7.18216ZM19.9022 8.36122L16.7822 9.75466V11.9431C16.7822 12.1207 16.712 12.2911 16.587 12.4168C16.4619 12.5424 16.2924 12.613 16.1156 12.613C15.9387 12.613 15.7692 12.5424 15.6442 12.4168C15.5191 12.2911 15.4489 12.1207 15.4489 11.9431V10.3442L13.3511 11.2821C13.1287 11.371 12.8999 11.4427 12.6667 11.4965V20C12.8104 19.9628 12.9503 19.9119 13.0844 19.8482L18.4178 17.4632C18.8887 17.2526 19.2887 16.9093 19.5696 16.475C19.8504 16.0406 19.9999 15.5338 20 15.0158V9.06687C19.9993 8.82829 19.9664 8.59092 19.9022 8.36122Z"
        stroke={color}
      />
    </svg>
  )
}

export default BoxIcon
